//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'UiIcon',

  props: {
    icon: String,
    iconSet: {
      type: String,
      default: 'material-icons',
    },
    ariaLabel: String,
    removeText: {
      type: Boolean,
      default: false,
    },
    useSvg: {
      type: Boolean,
      default: false,
    },
    mirror: {
      type: Boolean,
      default: false,
    },
  },
};

